import React from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToHashProps {
  location: ReturnType<typeof useLocation>;
}

class ScrollToHashClass extends React.Component<ScrollToHashProps> {
  componentDidMount() {
    this.scrollToHash();
  }

  componentDidUpdate(prevProps: ScrollToHashProps) {
    if (this.props.location !== prevProps.location) {
      this.scrollToHash();
    }
  }

  scrollToHash() {
    const { location } = this.props;
    if (location.hash) {
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  render() {
    return null;
  }
}

const ScrollToHash: React.FC = () => {
  const location = useLocation();
  return <ScrollToHashClass location={location} />;
};

export default ScrollToHash;
